import type { Container } from "inversify";
import type { IModule } from "./entities/Module";
import { CursorService } from "./services/CursorService";
import { type EngineConfig, EngineConfigService } from "./services/EngineConfig";

class CoreModule implements IModule {
	public readonly moduleName = "🧩 CoreModule";

	private engineConfigService!: EngineConfigService;
	private cursorService!: CursorService;

	constructor(private readonly config: EngineConfig = {}) {}

	public register(container: Container): void {
		container.bind(EngineConfigService).toConstantValue(new EngineConfigService({ ...this.config }));

		container.bind(CursorService).toSelf().inSingletonScope();
	}

	public initialize(container: Container): void {
		this.engineConfigService = container.get(EngineConfigService);
		this.cursorService = container.get(CursorService);

		this.engineConfigService.initialize();
		this.cursorService.initialize();
	}

	public dispose(): void {
		this.cursorService.dispose();
		this.engineConfigService.dispose();
	}

	public get api() {
		return {
			palette: this.engineConfigService.palette,
		};
	}
}

export { CoreModule };
